import accountService from '../service/account.service';
import {showWarning} from '../utils/notification.utils';

export function useCustomerStatement() {
  const getStatementAccountId = async (customerId) => {
    const params = {
      customerId: customerId,
      type: "CUSTOMER",
      page: "1",
      size: "10"
    };

    const response = await accountService.find(localStorage.getItem('mid'), params);
    if (!response.data.data || response.data.data.length < 1) {
      await showWarning("Customer has no accounts to view a statement for.");
      return null;
    }
    const account = response.data.data[0];
    return account.id;
  };

  return {
    getStatementAccountId,
  };
}



// WEBPACK FOOTER //
// ./src/composables/useCustomerStatement.js